import { MIGRATED_CATEGORY_SLUG, SESSION_WRAPS } from 'enums/il/il-categories'

export const DEFAULT_AUTHOR_LOGO = 'author-default-logo.svg'

export const IL_ARTICLE_DEFAULT_IMAGE = {
  GENERAL: 'il-article-default-general_original.jpeg',
  LATEST_NEWS: 'il-article-default-general_original.jpeg',
  SESSION_WRAP: 'il-article-default-general_original.jpeg',
  CENTRAL_BANKS: 'il-article-default-general_original.jpeg',
  CRYPTO: 'il-article-default-general_original.jpeg',
  FOREX_ORDERS: 'il-article-default-general_original.jpeg',
  TECHNICAL_ANALYSIS: 'il-article-default-general_original.jpeg'
}

export const IL_DEFAULT_IMAGE_BY_CATEGORY = {
  [MIGRATED_CATEGORY_SLUG.NEWS]: IL_ARTICLE_DEFAULT_IMAGE.LATEST_NEWS,
  [MIGRATED_CATEGORY_SLUG.CRYPTOCURRENCY]: IL_ARTICLE_DEFAULT_IMAGE.CRYPTO,
  [MIGRATED_CATEGORY_SLUG.CENTRAL_BANKS]:
    IL_ARTICLE_DEFAULT_IMAGE.CENTRAL_BANKS,
  [MIGRATED_CATEGORY_SLUG.ORDERS]: IL_ARTICLE_DEFAULT_IMAGE.FOREX_ORDERS,
  [MIGRATED_CATEGORY_SLUG.TECHNICAL_ANALYSIS]:
    IL_ARTICLE_DEFAULT_IMAGE.TECHNICAL_ANALYSIS,
  [SESSION_WRAPS]: IL_ARTICLE_DEFAULT_IMAGE.SESSION_WRAP
}
